import type { ReactNode } from 'react';

import type { MobileFiltersModalProps } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';
import { MobileFiltersModal } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';

import styles from './mobileFilterRow.module.css';

interface MobileFilterRowProps extends MobileFiltersModalProps {
  actionSlot?: ReactNode;
}

export function MobileFilterRow({
  actionSlot,
  ...props
}: MobileFilterRowProps) {
  return (
    <div className={styles['mobileFilterRow']}>
      <MobileFiltersModal {...props} />
      {actionSlot && (
        <div className={styles['mobileActionSlot']}>{actionSlot}</div>
      )}
    </div>
  );
}
